import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ModalEliminarCuenta = ({ show, onHide, cuenta, onConfirm, isDeleting }) => {
    const [confirmText, setConfirmText] = useState('');
    const palabraClave = "ELIMINAR";

    useEffect(() => {
        if (show) {
            setConfirmText('');
        }
    }, [show]);

    const isMatch = confirmText === palabraClave;

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="text-danger fw-bold">
                    <FontAwesomeIcon icon="triangle-exclamation" className="me-2" />
                    Eliminar Cuenta Bancaria
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-2">
                <p className="mb-2 text-dark">Estás a punto de eliminar la cuenta:</p>
                <div className="bg-light p-3 rounded mb-3 border">
                    <h6 className="fw-bold mb-1 text-dark">{cuenta?.vNombreBanco}</h6>
                    <div className="text-muted small">No. Cuenta: {cuenta?.vNumCta}</div>
                </div>
                <p className="text-danger mb-3 fw-medium" style={{ fontSize: '0.85rem' }}>
                    Esta acción es irreversible y podría afectar los registros contables vinculados a esta cuenta.
                </p>
                <Form.Group>
                    <Form.Label style={{ fontSize: '0.85rem' }} className="fw-medium text-muted">
                        Para confirmar, escribe la palabra <strong className="text-dark">{palabraClave}</strong>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder={palabraClave}
                        value={confirmText}
                        onChange={(e) => setConfirmText(e.target.value)}
                        autoComplete="off"
                        className={confirmText.length > 0 && !isMatch ? 'is-invalid' : (isMatch ? 'is-valid' : '')}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer className="border-0 pt-0">
                <Button variant="light" onClick={onHide} disabled={isDeleting} className="text-muted fw-bold">
                    Cancelar
                </Button>
                <Button variant="danger" onClick={onConfirm} disabled={!isMatch || isDeleting} className="fw-bold px-4 shadow-sm">
                    {isDeleting ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Eliminando...
                        </>
                    ) : (
                        <>
                            <FontAwesomeIcon icon="trash" className="me-2" />
                            Eliminar
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalEliminarCuenta.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    cuenta: PropTypes.shape({
        vNombreBanco: PropTypes.string,
        vNumCta: PropTypes.string
    }),
    onConfirm: PropTypes.func.isRequired,
    isDeleting: PropTypes.bool.isRequired
};

export default ModalEliminarCuenta;
